import { RpcUpdateData } from './rpc-update-data-model';

/**
 * Rpc update data sever side handler interface.
 */
export interface RpcUpdateDataHandler {
    handler(data: RpcUpdateData): Promise<void>;
}
